// extracted by mini-css-extract-plugin
export var modal = "_ei-0";